import { motion } from "framer-motion";
import { Icon } from "@iconify/react";

const STEPS = [
    {
        number: "01",
        icon: "mdi:account-plus-outline",
        title: "Cria a tua conta",
        description: "Regista-te na plataforma Honga Yetu com o teu email ou telefone. Uma conta, todos os serviços.",
        color: "from-blue-500 to-blue-600",
    },
    {
        number: "02",
        icon: "mdi:puzzle-plus-outline",
        title: "Escolhe os módulos",
        description: "Selecciona apenas os módulos de que a tua empresa precisa — Facturação, RH, Finanças, e mais.",
        color: "from-blue-500 to-blue-600",
    },
    {
        number: "03",
        icon: "mdi:cog-outline",
        title: "Configura a empresa",
        description: "Adiciona os dados da empresa, estabelecimentos, logótipo e configurações de impressão.",
        color: "from-purple-500 to-purple-600",
    },
    {
        number: "04",
        icon: "mdi:rocket-launch-outline",
        title: "Começa a trabalhar",
        description: "Emite facturas, gere funcionários, controla as finanças — tudo pronto para usar.",
        color: "from-amber-500 to-amber-600",
    },
];

export default function ComoFuncionaSection() {
    return (
        <section className="py-20 lg:py-28 bg-slate-900 relative overflow-hidden">
            {/* Background decoration */}
            <div className="absolute inset-0">
                <div className="absolute top-1/2 left-0 right-0 h-px bg-linear-to-r from-transparent via-white/10 to-transparent" />
            </div>

            <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                {/* Section header */}
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.5 }}
                    className="text-center mb-16"
                >
                    <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">
                        Como funciona?
                    </h2>
                    <p className="text-lg text-white/50 max-w-2xl mx-auto">
                        Em apenas 4 passos simples, a tua empresa estará pronta para operar.
                    </p>
                </motion.div>

                {/* Steps */}
                <div className="grid md:grid-cols-4 gap-8 relative">
                    {/* Connecting line (desktop) */}
                    <div className="hidden md:block absolute top-16 left-[12.5%] right-[12.5%] h-0.5 bg-linear-to-r from-blue-500/30 via-blue-500/30 via-purple-500/30 to-amber-500/30" />

                    {STEPS.map((step, index) => (
                        <motion.div
                            key={step.number}
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.5, delay: index * 0.12 }}
                            className="text-center relative"
                        >
                            {/* Step circle */}
                            <div className="relative inline-flex mb-6">
                                <div className={`w-20 h-20 rounded-2xl bg-linear-to-br ${step.color} flex items-center justify-center shadow-lg`}>
                                    <Icon icon={step.icon} width={34} className="text-white" />
                                </div>
                                <div className="absolute -top-2 -right-2 w-7 h-7 rounded-full bg-white text-slate-900 text-xs font-bold flex items-center justify-center shadow">
                                    {step.number}
                                </div>
                            </div>

                            <h3 className="text-lg font-semibold text-white mb-2">
                                {step.title}
                            </h3>
                            <p className="text-sm text-white/50 leading-relaxed max-w-xs mx-auto">
                                {step.description}
                            </p>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}
